import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";

function Overview (props) {

  const format = props.format
  const heatmap = props.heatmap
  const updateHeatmap = props.updateHeatmap
  const subheader = props.subheader
  const setSubheader = props.setSubheader

  const endpoints = props.endpoints
  const cells = props.cells
  const colorHeatmap = props.colorHeatmap

  const [visibility, setVisibility] = useState(true)

  const unit = 20
    
    useEffect(()=> {
       
        d3.select('#o_content').style('width', unit*endpoints.length+'px').selectAll('.o_cell').data(d3.merge(cells)).join(
            function(enter){
              enter.append('div')
                .attr('id', (d,i) => 'o_cell_'+i)
                .classed('o_cell', true)
                .style('width', unit-1+'px')
                .style('background-color', d => colorHeatmap(d.cases, d.ratio))
            },
            function(update){
              update.style('width', unit-1+'px')
                  .attr('id', (d,i) => 'o_cell_'+i)
                  .style('background-color', d => colorHeatmap(d.cases, d.ratio))
                  .on('mouseenter', function (e,d){
                      const cell = +d3.select(this).attr('id').replace('o_cell_','')
                      const row = Math.floor(cell/endpoints.length)
                      d3.select('#m_code_'+row).classed('m_highcode', true)
                      for (let i=0; i < endpoints.length; i++) {
                          const index = row*endpoints.length+i
                          if (i===0) document.getElementById('m_cell_'+index).scrollIntoView({behavior: "smooth", block: "center"});
                          d3.select('#m_cell_'+index).classed('m_highcell', true)
                          d3.select('#o_cell_'+index).classed('o_highcell', true)
                      }
                  })
                  .on('mouseleave', function (e,d){
                      const cell = +d3.select(this).attr('id').replace('o_cell_','')
                      const row = Math.floor(cell/endpoints.length)
                      d3.select('#m_code_'+row).classed('m_highcode', false)
                      for (let i=0; i < endpoints.length; i++) {
                          const index = row*endpoints.length+i
                          d3.select('#m_cell_'+index).classed('m_highcell', false)
                          d3.select('#o_cell_'+index).classed('o_highcell', false)
                      }
                  })
            }
        )

    })


    return (
        <div id='m_overview'
          style={{right: visibility ? 0 : document.getElementById('m_overview').getBoundingClientRect().width*(-1)+25+'px'}}
          onClick={() => {setVisibility(!visibility)}}
          >
          <h5 id="o_title">{visibility ? "\u25b8 \u2000Overview" : "\u25c2"}</h5>
          <div id="o_content" style={{opacity: visibility ? 1 : 0}}></div>
        </div>
    )
}

export default Overview;